'use client';

import { useState, useEffect, useCallback } from 'react';

export function useNavigationScroll() {
  const [isNavigationVisible, setIsNavigationVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  const controlNavigation = useCallback(() => {
    const currentScrollY = window.scrollY;

    // Threshold để tránh hiệu ứng flicker khi scroll nhẹ
    const scrollThreshold = 10;

    if (Math.abs(currentScrollY - lastScrollY) < scrollThreshold) {
      return;
    }

    if (currentScrollY < lastScrollY) {
      // Scroll up - show navigation
      setIsNavigationVisible(true);
    } else if (currentScrollY > lastScrollY && currentScrollY > 100) {
      // Scroll down and past 100px - hide navigation
      setIsNavigationVisible(false);
    }

    setLastScrollY(currentScrollY);
  }, [lastScrollY]);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.addEventListener('scroll', controlNavigation);

      return () => {
        window.removeEventListener('scroll', controlNavigation);
      };
    }
  }, [controlNavigation]);

  return { isNavigationVisible };
}
